module.exports = __webpack_public_path__ + "static/me_about-67ff37907d21f0fdb2570711bfa03d77.jpg";